import { render, staticRenderFns } from "./SaveConfigurationDialog.vue?vue&type=template&id=37ef129a&scoped=true"
import script from "./SaveConfigurationDialog.vue?vue&type=script&lang=js"
export * from "./SaveConfigurationDialog.vue?vue&type=script&lang=js"
import style0 from "./SaveConfigurationDialog.vue?vue&type=style&index=0&id=37ef129a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ef129a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
